import { useMemo } from 'react';

import { FieldStateKey, PermissionKey } from '@/common/constants';
import useGetPermissionToEditOverridableField from '@/modules/user/hooks/useGetPermissionToEditOverridableField';

const useGetExpressSetupLinksFieldsPermProps = () => {
  const externalLinkPermProps = useGetPermissionToEditOverridableField(
    PermissionKey.EXPRESS_SETUP_ENABLED,
    FieldStateKey.EXPRESS_SETUP_ENABLED
  );

  const hasFields = useMemo(
    () => [externalLinkPermProps].some((item) => !item.isAbsent),
    [externalLinkPermProps]
  );

  return {
    externalLinkPermProps,
    hasFields,
  };
};

export default useGetExpressSetupLinksFieldsPermProps;
